import React, { useEffect, useState } from 'react';

import { useForm, Controller } from 'react-hook-form';

import InputMask from 'react-input-mask';

import {
  MdChevronLeft,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdSearch,
  MdArrowDropDown,
  MdErrorOutline,
  MdArrowDropUp,
} from 'react-icons/md';

import { Pagination, Modal, Select, Tabs, Row, Col } from 'antd';

import { ClipLoader } from 'react-spinners';

import { format } from 'date-fns';

import ptBR from 'date-fns/locale/pt-BR';

import Breadcumbs from '~/components/Breadcumbs';

import api from '~/services/api';

import { store } from '~/store';

import history from '~/services/history';

import {
  PageTitle,
  BreadcumbsContainer,
  BoxContent,
  BoxContentHeader,
  BoxList,
  BoxPagination,
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './style';

import ButtonBack from '~/components/ButtonBack';
import { ButtonOrderBy } from '~/components/ButtonOrderBy';
import DescricaoModal from './descricaoModal';
import DescricaoModalAnterior from './descricaoModalAnterior';
import RenderDescription from './renderDescription';
import { AiOutlinePlus, AiOutlineRightCircle } from 'react-icons/ai';

const { Option } = Select;
const { TabPane } = Tabs;

const ResumoDeEventos = props => {
  const { register, handleSubmit, control, setValue } = useForm();

  const [data, setData] = useState([]);

  const [totalCount, setTotalCount] = useState(null);

  const [loading, setLoading] = useState(true);

  const { token } = store.getState().auth;

  const [noResults, setNoResults] = useState(false);

  const [pageCurrent, setPageCurrent] = useState(1);

  const [modalDescricao, setModalDescricao] = useState(false);

  const [modalData, setModalData] = useState();

  const [modalDataResponsavel, setModalDataResponsavel] = useState();

  const [tipoDeOperacaoModal, setIipoDeOperacaoModal] = useState();

  const [dataAudit, setDataAudit] = useState();

  const [idInstituicao, setIdInstituicao] = useState(null);

  const [tipoDeOperacao, setIipoDeOperacao] = useState(null);

  const [tipoPage, setTipoPage] = useState(null);

  // const [filterType, setFilterType] = useState('evento');
  const [filterType, setFilterType] = useState();

  const [searchText, setSearchText] = useState();

  const title_SUBMISSAO_DADOS =
    'Resumo de eventos para submissão de Indicadores Gerais';
  const title_CADASTRO_USUARIO = 'Resumo de eventos para cadastros de usuários';
  const title_ATUALIZACAO_PERFIL =
    'Resumo de eventos para atualização de perfil';
  const title_REABIR_COMPETENCIA =
    'Resumo de eventos para reaberturas de competência';
  const title_ADICAO_LINHA_CUIDADO =
    'Resumo de eventos para submissão de Linhas de Cuidado';
  const title_ADICAO_LINHA_CUIDADO_EXPORTS =
    'Resumo de eventos para exportação de dados';

  const title_ATUALIZAO_SUPORTE =
    'Resumo de eventos para atualização da área de suporte';
  const title_CADASTRO_INSTITUICAO =
    'Resumo de eventos para cadastro de instituição';

  const limit = 5;
  const auditoriaIndicadoresGerais = `auditoria/indicadores-gerais/instituicao/${idInstituicao}?limit=${limit}&offset=0`;
  const auditoriaUsuarios = `auditoria/usuarios/instituicao/${idInstituicao}?limit=${limit}&offset=0`;
  const auditoriaPerfilInstituicao = `auditoria/perfis-instituicoes/${idInstituicao}?limit=${limit}&offset=0`;
  const auditoriaInstituicao = `auditoria/instituicoes?limit=${limit}&offset=0`;
  const auditoriaReaberturaCompetencia = `auditoria/reabertura-competencias/instituicao/${idInstituicao}?limit=${limit}&offset=0`;
  const auditoriaRecursoAjuda = `auditoria/recursos-ajuda?limit=${limit}&offset=0`;
  const auditoriaLinhaDeCuidado = `auditoria/indicadores-linha-de-cuidado/instituicao/${idInstituicao}?limit=${limit}&offset=0`;
  const auditoriaExports = `auditoria/indicadores-linha-de-cuidado/exports?limit=${limit}&offset=0`;

  // ENDPOINTS FILTROS
  const auditoriaIndicadoresGerais_Filter = `auditoria/indicadores-gerais/instituicao/${idInstituicao}`;
  const auditoriaUsuarios_Filter = `auditoria/usuarios/instituicao/${idInstituicao}`;
  const auditoriaPerfilInstituicao_Filter = `auditoria/perfis-instituicoes/${idInstituicao}`;
  const auditoriaInstituicao_Filter = `auditoria/instituicoes`;
  const auditoriaReaberturaCompetencia_Filter = `auditoria/reabertura-competencias/instituicao/${idInstituicao}`;
  const auditoriaLinhaDeCuidado_Filter = `auditoria/indicadores-linha-de-cuidado/instituicao/${idInstituicao}`;
  const auditoriaRecursoAjuda_Filter = `auditoria/recursos-ajuda`;
  const auditoriaExports_Filter = `auditoria/indicadores-linha-de-cuidado/exports`;

  const [directionAsc, setDirectionAsc] = useState(true);

  const [orderBy, setOrderBy] = useState('');

  const getData = async props => {
    const type = props?.type;
    const order = props?.orderBy || '';
    const dir = props?.dir;

    setOrderBy(order);

    const endPoint =
      (type === 'SUBMISSAO_DADOS' && auditoriaIndicadoresGerais) ||
      (type === 'CADASTRO_USUARIO' && auditoriaUsuarios) ||
      (type === 'ATUALIZACAO_PERFIL' && auditoriaPerfilInstituicao) ||
      (type === 'REABIR_COMPETENCIA' && auditoriaReaberturaCompetencia) ||
      (type === 'ADICAO_LINHA_CUIDADO' && auditoriaLinhaDeCuidado) ||
      (type === 'EXPORTACAO_DADOS' && auditoriaExports) ||
      (type === 'ATUALIZAO_SUPORTE' && auditoriaRecursoAjuda) ||
      (type === 'CADASTRO_INSTITUICAO' && auditoriaInstituicao);

    try {
      const response = await api.get(
        `${endPoint}${`&orderBy=${order}`}&direction=${dir ? 'asc' : 'desc'}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setData(response.data);
      setTotalCount(response.headers['total-count']);

      setPageCurrent(1);

      if (response.data.length < 1) {
        setNoResults(true);
      }
      setLoading(false);
    } catch (error) {
      setNoResults(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (idInstituicao && tipoDeOperacao) {
      getData({ type: tipoDeOperacao });
    }

    setTipoPage(
      (tipoDeOperacao === 'SUBMISSAO_DADOS' && title_SUBMISSAO_DADOS) ||
        (tipoDeOperacao === 'CADASTRO_USUARIO' && title_CADASTRO_USUARIO) ||
        (tipoDeOperacao === 'ATUALIZACAO_PERFIL' && title_ATUALIZACAO_PERFIL) ||
        (tipoDeOperacao === 'REABIR_COMPETENCIA' && title_REABIR_COMPETENCIA) ||
        (tipoDeOperacao === 'ADICAO_LINHA_CUIDADO' &&
          title_ADICAO_LINHA_CUIDADO) ||
        (tipoDeOperacao === 'EXPORTACAO_DADOS' &&
          title_ADICAO_LINHA_CUIDADO_EXPORTS) ||
        (tipoDeOperacao === 'ATUALIZAO_SUPORTE' && title_ATUALIZAO_SUPORTE) ||
        (tipoDeOperacao === 'CADASTRO_INSTITUICAO' &&
          title_CADASTRO_INSTITUICAO)
    );
  }, [tipoDeOperacao, idInstituicao]);

  useEffect(() => {
    setIdInstituicao(props.location.state.idInstituicao);
    setIipoDeOperacao(props.location.state.type);
  }, []);

  const paginationRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return (
        <a className="arrowLeft">
          <MdKeyboardArrowLeft size={25} /> Anterior
        </a>
      );
    }
    if (type === 'next') {
      return (
        <a className="arrowRight">
          Próximo <MdKeyboardArrowRight size={25} />
        </a>
      );
    }
    return originalElement;
  };

  const paginationChange = async page => {
    setPageCurrent(page);
    const endPoint =
      (tipoDeOperacao === 'SUBMISSAO_DADOS' &&
        auditoriaIndicadoresGerais_Filter) ||
      (tipoDeOperacao === 'CADASTRO_USUARIO' && auditoriaUsuarios_Filter) ||
      (tipoDeOperacao === 'ATUALIZACAO_PERFIL' &&
        auditoriaInstituicao_Filter) ||
      (tipoDeOperacao === 'REABIR_COMPETENCIA' &&
        auditoriaReaberturaCompetencia_Filter) ||
      (tipoDeOperacao === 'ADICAO_LINHA_CUIDADO' &&
        auditoriaLinhaDeCuidado_Filter) ||
      (tipoDeOperacao === 'EXPORTACAO_DADOS' &&
        auditoriaLinhaDeCuidado_Filter) ||
      (tipoDeOperacao === 'ATUALIZAO_SUPORTE' && auditoriaExports_Filter) ||
      (tipoDeOperacao === 'CADASTRO_INSTITUICAO' &&
        auditoriaInstituicao_Filter);

    if (searchText || filterType) {
      const limitOffset = page - 1;
      const offset = page <= 1 ? 0 : limitOffset * limit;

      await api
        .get(
          `${endPoint}?limit=${limit}&offset=${offset}&${filterType}=${searchText ||
            'INSERT'}`,
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then(response => {
          setData(response.data);
          setTotalCount(response.headers['total-count']);
          setLoading(false);
        });

      return;
    }

    setLoading(true);
    const limitOffset = page - 1;
    const offset = page <= 1 ? 0 : limitOffset * limit;

    await api
      .get(`${endPoint}?limit=${limit}&offset=${offset}`, {
        headers: {
          Authorization: token,
        },
      })
      .then(response => {
        setData(response.data);
        setTotalCount(response.headers['total-count']);
        setLoading(false);
      });
  };

  const handleChangeFilter = value => {
    setSearchText('');

    setFilterType(value);
  };

  const handleTermFilter = search => {
    setSearchText(search);
  };

  const filterUsuarios = async value => {
    const { search } = value;

    console.log('value', value);
    console.log('filterType', filterType);

    let defaultSearch;
    if (search || filterType === 'evento') {
      defaultSearch = 'INSERT';
    } else {
      defaultSearch = '';
    }

    setLoading(true);
    setNoResults(false);
    const endPoint =
      (tipoDeOperacao === 'SUBMISSAO_DADOS' &&
        auditoriaIndicadoresGerais_Filter) ||
      (tipoDeOperacao === 'CADASTRO_USUARIO' && auditoriaUsuarios_Filter) ||
      (tipoDeOperacao === 'ATUALIZACAO_PERFIL' &&
        auditoriaPerfilInstituicao_Filter) ||
      (tipoDeOperacao === 'REABIR_COMPETENCIA' &&
        auditoriaReaberturaCompetencia_Filter) ||
      (tipoDeOperacao === 'ADICAO_LINHA_CUIDADO' &&
        auditoriaLinhaDeCuidado_Filter) ||
      (tipoDeOperacao === 'EXPORTACAO_DADOS' && auditoriaExports_Filter) ||
      (tipoDeOperacao === 'ATUALIZAO_SUPORTE' &&
        auditoriaRecursoAjuda_Filter) ||
      (tipoDeOperacao === 'CADASTRO_INSTITUICAO' &&
        auditoriaInstituicao_Filter);

    try {
      await api
        .get(
          `${endPoint}?${filterType || 'descricao'}=${
            filterType === 'dataCriacao' ? search : searchText || defaultSearch
          }`,
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then(response => {
          setData(response.data);
          setTotalCount(response.headers['total-count']);
          setLoading(false);
          if (response.data.length < 1) {
            setNoResults(true);
          }
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const descricao =
    (tipoDeOperacao === 'SUBMISSAO_DADOS' && 'Submissão de dados') ||
    (tipoDeOperacao === 'CADASTRO_USUARIO' && 'Cadastro de usuário') ||
    (tipoDeOperacao === 'ATUALIZACAO_PERFIL' && 'Atualização de perfil') ||
    (tipoDeOperacao === 'REABIR_COMPETENCIA' && 'Reabertura de competência') ||
    (tipoDeOperacao === 'ADICAO_LINHA_CUIDADO' &&
      'Adição de Linha de Cuidado') ||
    (tipoDeOperacao === 'EXPORTACAO_DADOS' && 'Exportação de dados') ||
    (tipoDeOperacao === 'ATUALIZAO_SUPORTE' && 'Atualização de suporte') ||
    (tipoDeOperacao === 'CADASTRO_INSTITUICAO' && 'Cadastro de instituição');

  const getDataAudit = async idVersao => {
    if (tipoDeOperacao === 'EXPORTACAO_DADOS') {
      return;
    }

    const endPoint =
      (tipoDeOperacao === 'SUBMISSAO_DADOS' && 'indicadores-gerais') ||
      (tipoDeOperacao === 'CADASTRO_USUARIO' && 'usuarios') ||
      (tipoDeOperacao === 'ATUALIZACAO_PERFIL' && 'perfis-instituicoes') ||
      (tipoDeOperacao === 'REABIR_COMPETENCIA' && 'reabertura-competencias') ||
      (tipoDeOperacao === 'ADICAO_LINHA_CUIDADO' &&
        'indicadores-linha-de-cuidado') ||
      (tipoDeOperacao === 'ATUALIZAO_SUPORTE' && 'recursos-ajuda') ||
      (tipoDeOperacao === 'CADASTRO_INSTITUICAO' && 'instituicoes');

    const response = await api.get(`auditoria/${endPoint}/versao/${idVersao}`, {
      headers: {
        Authorization: token,
      },
    });

    setDataAudit(response.data);
  };

  const descricaoOperacao = dados => {
    setModalData(dados);
    setModalDescricao(true);
  };

  const descricaoResponsavel = dados => {
    setModalDataResponsavel(dados);

    const { versaoAuditedId } = dados;
    getDataAudit(versaoAuditedId);
  };

  const fecharModal = () => {
    setModalDescricao(false);
    setTimeout(() => {
      setModalData(null);
    }, 200);
  };

  return (
    <>
      <Modal
        visible={modalDescricao}
        onOk={() => fecharModal()}
        onCancel={() => fecharModal()}
        centered
        footer={null}
      >
        <ModalContainer>
          <ModalHeader>
            <h2>
              <span>{descricao}</span>
            </h2>
          </ModalHeader>
          {tipoDeOperacaoModal === 'UPDATE' ? (
            <Tabs
              tabBarStyle={{
                display: 'flex',
                justifyContent: 'center',
              }}
              className="tabsContainer"
              defaultActiveKey="1"
              size="small"
            >
              <TabPane tab="Atual" key="1">
                <div className="ModalBody">
                  <div>
                    <DescricaoModal
                      tipoDeOperacao={tipoDeOperacao}
                      modalData={modalData}
                      modalDataResponsavel={modalDataResponsavel}
                    />
                  </div>
                </div>
              </TabPane>
              <TabPane tab="Anterior" key="2">
                <div className="ModalBody ModalBodyAnterior">
                  <div>
                    <DescricaoModalAnterior
                      tipoDeOperacao={tipoDeOperacao}
                      modalData={dataAudit?.antes?.data}
                      modalDataResponsavel={dataAudit?.antes?.responsavel}
                    />
                  </div>
                </div>
              </TabPane>
            </Tabs>
          ) : (
            <div className="ModalBody">
              <div>
                <DescricaoModal
                  tipoDeOperacao={tipoDeOperacao}
                  modalData={modalData}
                  modalDataResponsavel={modalDataResponsavel}
                />
              </div>
            </div>
          )}
        </ModalContainer>

        <ModalFooter>
          <ButtonModal type="button" onClick={() => setModalDescricao(false)}>
            OK
          </ButtonModal>
        </ModalFooter>
      </Modal>

      <Breadcumbs path="resumo-de-eventos" pathTitle="Resumo de eventos" />
      <BreadcumbsContainer>
        <ButtonBack />
      </BreadcumbsContainer>

      <PageTitle>
        <div className="headerInline">
          <span>{tipoPage || ''}</span>

          <div className="boxSearch">
            <form onSubmit={handleSubmit(filterUsuarios)}>
              <Select
                defaultValue="descricao"
                style={{ width: filterType === 'dataCriacao' ? 150 : 120 }}
                onChange={handleChangeFilter}
              >
                <Option value="descricao">Descrição</Option>

                {tipoDeOperacao !== 'EXPORTACAO_DADOS' && (
                  <Option value="evento">Evento</Option>
                )}

                {tipoDeOperacao !== 'EXPORTACAO_DADOS' && (
                  <Option value="dataCriacao">Data de criação</Option>
                )}
              </Select>
              {filterType === 'evento' && (
                <Select
                  defaultValue="INSERT"
                  style={{ width: 120 }}
                  onChange={handleTermFilter}
                >
                  <Option value="INSERT">Inclusão</Option>
                  <Option value="UPDATE">Atualização</Option>

                  {tipoDeOperacao !== 'CADASTRO_USUARIO' &&
                    tipoDeOperacao !== 'REABIR_COMPETENCIA' && (
                      <Option value="DELETE">Exclusão</Option>
                    )}
                </Select>
              )}
              {filterType !== 'dataCriacao' && filterType !== 'evento' && (
                <label htmlFor="search">
                  <MdSearch size={18} color="#619b30" />
                  <input
                    name="search"
                    id="search"
                    placeholder={`${
                      filterType === 'dataCriacao' ? 'dd/mm/aaaa' : 'Pesquisar'
                    }  `}
                    onChange={e => setSearchText(e.target.value)}
                  />
                </label>
              )}

              {filterType === 'dataCriacao' && (
                <label htmlFor="search">
                  <MdSearch size={18} color="#619b30" />

                  <Controller
                    as={InputMask}
                    name="search"
                    id="search"
                    control={control}
                    mask="99/99/9999"
                    placeholder="Pesquisar por data"
                    defaultValue={searchText || ''}
                  />
                </label>
              )}
              <button className="botao-verde" type="submit">
                Buscar
              </button>
            </form>
          </div>
        </div>
      </PageTitle>

      {data.length > 0 ? (
        <BoxContent>
          <BoxContentHeader>
            <Row>
              <Col span={5}>
                <ButtonOrderBy
                  isActive={orderBy === 'tipo_operacao'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    getData({
                      type: tipoDeOperacao,
                      orderBy: 'tipo_operacao',
                      dir: !directionAsc,
                    });
                  }}
                >
                  <span>
                    Evento{' '}
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </Col>

              <Col span={14}>
                <span className="descricaoHeader">Descrição</span>
              </Col>

              <Col span={5}>
                <div className="dataHoraHeader">
                  <ButtonOrderBy
                    isActive={orderBy === 'dataCriacao'}
                    onClick={() => {
                      setDirectionAsc(!directionAsc);
                      getData({
                        type: tipoDeOperacao,
                        orderBy: 'dataCriacao',
                        dir: !directionAsc,
                      });
                    }}
                  >
                    <span>
                      Data/Hora{' '}
                      {directionAsc ? (
                        <MdArrowDropDown size={20} />
                      ) : (
                        <MdArrowDropUp size={20} />
                      )}
                    </span>
                  </ButtonOrderBy>
                </div>
              </Col>
            </Row>
          </BoxContentHeader>

          {data.map((operacao, index) => {
            const { tipo_operacao, responsavel } = operacao;

            const operacaoData = operacao.data;

            {
              /* let descricaoExports

            if (tipoDeOperacao === 'EXPORTACAO_DADOS') {
              descricaoExports = operacao?.data?.nomeLinhaCuidado;
            } */
            }

            const tipoOperac =
              (tipo_operacao === 'UPDATE' && 'Atualização') ||
              (tipo_operacao === 'INSERT' && 'Inclusão ') ||
              (tipo_operacao === 'DELETE' && 'Exclusão');

            const { dataCriacao, email } = responsavel;

            return (
              <BoxList key={String(index)}>
                <Row>
                  <Col span={5}>
                    <div className="evento">
                      <span>
                        {tipoOperac ||
                          (tipoDeOperacao === 'EXPORTACAO_DADOS' &&
                            'Exportação')}{' '}
                      </span>
                    </div>
                  </Col>

                  <Col span={14}>
                    <div className="evento descricao">
                      <div className="descriptionGrid">
                        <div>
                          <RenderDescription
                            tipoDeOperacao={tipoDeOperacao}
                            modalData={operacao}
                          />
                        </div>

                        <div className="buttonDetalhes">
                          <button
                            type="button"
                            onClick={() => {
                              descricaoOperacao(operacaoData);
                              descricaoResponsavel(responsavel);
                              setIipoDeOperacaoModal(tipo_operacao);
                            }}
                          >
                            <AiOutlinePlus />
                            <span>Mais detalhes</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col span={5}>
                    <div className="evento">
                      <span>
                        {dataCriacao &&
                          format(
                            new Date(`${dataCriacao}`),
                            'dd/MM/yyyy - HH:mm:ss',
                            {
                              locale: ptBR,
                            }
                          )}
                      </span>
                    </div>
                  </Col>
                </Row>
              </BoxList>
            );
          })}

          {data.length > 0 && (
            <BoxPagination>
              <Pagination
                current={pageCurrent}
                pageSize={limit}
                onChange={paginationChange}
                total={Number(totalCount)}
                itemRender={paginationRender}
              />
            </BoxPagination>
          )}
        </BoxContent>
      ) : (
        <BoxContent>
          {noResults && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                minHeight: '300px',
                textAlign: 'center',
                color: '#666',
                fontSize: '14px',
              }}
            >
              <MdErrorOutline size="40" color="#666" />
              <br />
              <p style={{ color: '#666' }}>Nenhum resultado encontrado.</p>
            </div>
          )}
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      )}
    </>
  );
};

export default ResumoDeEventos;
